import { IOfficeholder } from '../../../types';

export default function officeholdersToObject(
  officeholders: IOfficeholder[]
): { [key: string]: IOfficeholder } {
  const final: { [key: string]: IOfficeholder } = {};

  officeholders.forEach(officeholder => {
    if (!officeholder.identifiers.length) {
      return;
    }

    const guten = officeholder.identifiers.filter(
      identifier => identifier.scheme === 'guten-tags'
    );

    if (!guten.length) {
      return;
    }

    final[guten[0].identifier] = officeholder;
  });

  return final;
}
